

exports.__esModule = true;
exports.$SidebarUpdateShippingRoute = undefined;

var _squid = require('squid');

require('./directive');

require('xo-member-components/src/select-shipping/update-shipping/route');

var $SidebarUpdateShippingRoute = exports.$SidebarUpdateShippingRoute = _squid.$ComponentRoute.extend('$SidebarUpdateShippingRoute', {

    path: 'sidebarUpdateShipping',
    directive: 'xo-sidebar-Update-shipping-page',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        templateName: 'tray/addShippingAddress.dust',
        pageGoal: 'Update Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$UpdateShippingRoute',
        attributes: {
            token: 'token'
        },
        message: 'message',
        sidebar: 'sidebar',
        'parent-callbacks': 'callbacks'
    }]
});

angular.value("$SidebarUpdateShippingRoute", $SidebarUpdateShippingRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-shipping/route.js
// module id = ./pages/xo-sidebar-update-shipping/route.js
// module chunks = 1